import { Table } from "@mantine/core";
import { useCallback } from "react";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { DateTimeDisp } from "src/components/shared/DateTime";
import Loader from "src/components/shared/Loader/Loader";
import { useGetApi } from "src/hooks";
import { type ILink } from "src/interfaces";
import { PageContainer, StyledTd, StyledTh, StyledTr } from "src/styled";
import { getYachtId } from "src/utils";

import { LayoutContainer } from "../VesselParticulars/YachtSetupHistory/YachtSetupHistory.styled";

interface ILiftingEquipmentHistoryItem {
  id: string;
  full_name: string;
  rolename: string;
  datecreatedLT: string;
  datecreatedUTC: string;
}

const mapHistoryItems = (data: any): ILiftingEquipmentHistoryItem[] =>
  data?.list ?? [];

const LiftingEquipmentHistory = () => {
  const { data, isLoading } = useGetApi({
    request: "get-lifting-equipment-history",
    body: { params: { yachtid: getYachtId() } },
    mapper: mapHistoryItems,
  });

  const getLinks = useCallback((links: ILink[]) => {
    const yachtIndex = links.findIndex(link => link.href === "/settings/yacht");
    const prefix =
      yachtIndex >= 0 ? links.slice(0, yachtIndex + 1) : links.slice(0, -2);

    return [
      ...prefix,
      {
        title: "Lifting Equipment",
        href: "/settings/yacht/lifting",
      },
      {
        title: "History",
        href: "/settings/yacht/history/lifting",
      },
    ];
  }, []);

  const renderUser = useCallback((role: string, name: string) => {
    let text = "";
    if (role) text += role;
    if (name) text += ` ${name}`;
    return text;
  }, []);

  return (
    <PageContainer>
      <Breadcrumbs customLinks={getLinks} />
      <LayoutContainer>
        <Table>
          <thead>
            <StyledTr>
              <StyledTh>Edit description</StyledTh>
              <StyledTh>Edited by</StyledTh>
              <StyledTh>Edit date</StyledTh>
            </StyledTr>
          </thead>
          <tbody>
            {data &&
              !isLoading &&
              data.map(row => (
                <StyledTr key={row.id}>
                  <StyledTd>Lifting Equipment Details Updated</StyledTd>
                  <StyledTd>{renderUser(row.rolename, row.full_name)}</StyledTd>
                  <StyledTd>
                    <DateTimeDisp
                      lt={row.datecreatedLT}
                      utc={row.datecreatedUTC}
                      dir="row"
                    />
                  </StyledTd>
                </StyledTr>
              ))}
          </tbody>
        </Table>
      </LayoutContainer>
      {!(data ?? isLoading) && <Loader />}
    </PageContainer>
  );
};

export default LiftingEquipmentHistory;
